import { render, staticRenderFns } from "./SuspectCodeModelsHeader.vue?vue&type=template&id=1d66c959&lang=pug"
import script from "./SuspectCodeModelsHeader.vue?vue&type=script&lang=js"
export * from "./SuspectCodeModelsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports